import {z} from 'zod';

export const analyticsScriptSchema = z.object({
    html: z.string(),
    tracking: z.object({
        metaHeadStart: z.string(),
        metaHeadEnd: z.string(),
        metaBodyStart: z.string(),
        metaBodyEnd: z.string(),
    }),
    isConsentRequired: z.boolean(),
});

export type AnalyticsScript = z.infer<typeof analyticsScriptSchema>;
